
<h3 *ngIf="recipientEmail" class="people-card-email">
  <img src="../../../assets/images/icon-email-purple.png" class="copy-icon">
  <a  (click)="openSendMessageDialog()" recipientEmail>Send message</a>
</h3>

